import { useEffect } from "react";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../constant/colors";
import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { formateDateWithTime } from "../../utils/commonFunctions";
import { PaperClipIcon } from "../Icon";
import { CircularAvatar } from "../commons";
import UpdatedByAndUpdatedAt from "../commons/CommonUpdatedByAndUpdatedAt";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";

type AppProps = {
  tableHeader: TableHeadersType[] | [];
  leadDirectoryList: [] | any[];
  handleEditLeadModule: (id: number) => void;
  isEditClientLeadDetailsPresent: boolean;
  handleToggleLeadCommentsModal?: () => void;
  handleSetLeadData?: (data: any) => void;
  offset: number;
  handleChangeLeadStatus: (data: any) => void;
};

const LeadModuleTableData = ({
  tableHeader,
  leadDirectoryList,
  handleEditLeadModule,
  isEditClientLeadDetailsPresent,
  handleToggleLeadCommentsModal,
  handleSetLeadData,
  offset,
  handleChangeLeadStatus,
}: AppProps) => {
  //========== User Management==========//
  const [isAddLeadCommentsPresent, setIsAddLeadCommentsPresent] =
    useMenuCheck();

  //====================//

  let todayDate = moment(new Date()).format("DD-MM-YYYY");

  useEffect(() => {
    setIsAddLeadCommentsPresent("Lead Module Comments", "menu");
  }, []);

  const backColor = (name: string) => {
    const lowerCaseName = name.toLowerCase();

    let backgroundColor;
    let fontColor;

    if (lowerCaseName.startsWith("1")) {
      backgroundColor = STAGE_COLOR_CODES[0];
      fontColor = FONT_COL_CODES[0];
    } else if (
      lowerCaseName.startsWith("2a") ||
      lowerCaseName.startsWith("2b") ||
      lowerCaseName.startsWith("2bii") ||
      lowerCaseName.startsWith("2biii") ||
      lowerCaseName.startsWith("2biv") ||
      lowerCaseName.startsWith("2bv")
    ) {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (
      lowerCaseName.startsWith("2c") ||
      lowerCaseName.startsWith("2d")
    ) {
      backgroundColor = STAGE_COLOR_CODES[2];
      fontColor = FONT_COL_CODES[2];
    } else if (
      lowerCaseName.startsWith("3a") ||
      lowerCaseName.startsWith("3b")
    ) {
      backgroundColor = STAGE_COLOR_CODES[3];
      fontColor = FONT_COL_CODES[3];
    } else if (
      lowerCaseName.startsWith("4a") ||
      lowerCaseName.startsWith("4b") ||
      lowerCaseName.startsWith("5")
    ) {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    } else if (
      lowerCaseName.startsWith("6a") ||
      lowerCaseName.startsWith("6b") ||
      lowerCaseName.startsWith("6c") ||
      lowerCaseName.startsWith("6d") ||
      lowerCaseName.startsWith("6e")
    ) {
      backgroundColor = STAGE_COLOR_CODES[5];
      fontColor = FONT_COL_CODES[5];
    } else if (name == "COLD") {
      backgroundColor = "#E3EFFF";
      fontColor = "#2080F6";
    } else if (name == "HOT") {
      backgroundColor = "#FDE0D3";
      fontColor = "#E7733E";
    } else if (name == "WARM") {
      backgroundColor = "#FAEDD8";
      fontColor = "#F3A119";
    } else {
      backgroundColor = STAGE_COLOR_CODES[6];
      fontColor = FONT_COL_CODES[6];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };
  const styleColor = (name: string) => {
    const { backgroundColor, fontColor } = backColor(name);

    return {
      marginTop: "20px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };
  const calMAxLen = () => {
    let maxLength = 0;
    let height = 0;
    leadDirectoryList?.map((data) => {
      maxLength =
        maxLength > data?.company_name?.length
          ? maxLength
          : data?.company_name?.length;
    });
    if (maxLength > 0 && maxLength <= 30) {
      height = 60;
    } else if (maxLength > 30 && maxLength < 100) {
      height = 90;
    } else {
      height = 120;
    }
    return 90;
  };

  return (
    <>
      {leadDirectoryList?.length > 0 &&
        leadDirectoryList?.map((LeadModuleListData: any) => {
          const checkEndDate = moment(LeadModuleListData?.due_date).format(
            "DD-MM-YYYY"
          );
          const checkToday = moment(new Date()).format("DD-MM-YYYY");

          let targetEndDate = LeadModuleListData?.due_date ? (
            <span>{checkEndDate}</span>
          ) : (
            <span>--/--</span>
          );

          if (
            moment(checkEndDate, "DD-MM-YYYY").isBefore(
              moment(checkToday, "DD-MM-YYYY")
            )
          ) {
            targetEndDate = (
              <span className="status-Rejected">
                {LeadModuleListData?.due_date ? checkEndDate : "--/--"}
              </span>
            );
          }

          return (
            <tr
              className="text-left"
              style={{
                whiteSpace: "nowrap",
                lineHeight: "0.23",
                height: `${calMAxLen()}px`,
              }}
            >
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "client_email") {
                    return (
                      <td className="text-left mt-2">
                        <div style={{ paddingTop: "1px" }}>
                          <span style={{ display: "block", lineHeight: "1.5" }}>
                            {LeadModuleListData?.client_email}{" "}
                          </span>
                          <br />
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "12px",
                              display: "block",
                              marginTop: "6px",
                            }}
                          >
                            {LeadModuleListData?.client_contact_number &&
                              LeadModuleListData?.client_contact_number}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header?.value === "attachments") {
                    return LeadModuleListData?.attachments?.length ? (
                      <td className="position-relative">
                        <PaperClipIcon />
                        <span className="badge count-badge">
                          {LeadModuleListData?.attachments?.length}
                        </span>
                      </td>
                    ) : (
                      <td>
                        {" "}
                        <div style={{ paddingTop: "14px" }}>--/-- </div>
                      </td>
                    );
                  } else if (header?.value == "client_contact_number") {
                    return (
                      <td className="text-left mt-2">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.client_contact_number}
                        </div>
                      </td>
                    );
                  } else if (header?.value == "entity") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.entity}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "client_category") {
                    const clientCategoryArray =
                      LeadModuleListData?.client_category || "[]";
                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {clientCategoryArray?.length > 2 ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="send-email-tooltip">
                                {clientCategoryArray.length > 0
                                  ? clientCategoryArray?.map(
                                      (category: string, index: number) => (
                                        <div>{category}</div>
                                      )
                                    )
                                  : "--/--"}
                              </Tooltip>
                            }
                          >
                            <div
                              style={{ lineHeight: "1.5", paddingTop: "14px" }}
                            >
                              <div>{clientCategoryArray[0]}</div>
                              <div>{clientCategoryArray[1]}...</div>
                            </div>
                          </OverlayTrigger>
                        ) : (
                          <div
                            style={{ lineHeight: "1.5", paddingTop: "14px" }}
                          >
                            {clientCategoryArray[0] ? (
                              <div>{clientCategoryArray[0]}</div>
                            ) : null}
                            {clientCategoryArray[1] ? (
                              <div>{clientCategoryArray[1]}</div>
                            ) : null}
                            {clientCategoryArray?.length === 0 && "--/--"}
                          </div>
                        )}
                      </td>
                    );
                  } else if (header?.value === "due_date") {
                    return <td><div style={{ lineHeight: "1.5", paddingTop: "8px" }}>{targetEndDate}</div></td>;
                  } else if (header?.value === "scope_of_work") {
                    const scopeOfWorkArray =
                      LeadModuleListData?.scope_of_work || "[]";
                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {scopeOfWorkArray?.length > 2 ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="send-email-tooltip">
                                {scopeOfWorkArray.length > 0
                                  ? scopeOfWorkArray?.map(
                                      (scope: string, index: number) => (
                                        <div>{scope}</div>
                                      )
                                    )
                                  : "--/--"}
                              </Tooltip>
                            }
                          >
                            <div
                              style={{ lineHeight: "1.5", paddingTop: "14px" }}
                            >
                              <div>{scopeOfWorkArray[0]}</div>
                              <div>{scopeOfWorkArray[1]}...</div>
                            </div>
                          </OverlayTrigger>
                        ) : (
                          <div
                            style={{ lineHeight: "1.5", paddingTop: "14px" }}
                          >
                            {scopeOfWorkArray[0] ? (
                              <div>{scopeOfWorkArray[0]}</div>
                            ) : null}
                            {scopeOfWorkArray[1] ? (
                              <div>{scopeOfWorkArray[1]}</div>
                            ) : null}
                            {scopeOfWorkArray?.length === 0 && "--/--"}
                          </div>
                        )}
                      </td>
                    );
                  } else if (header?.value == "city") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.city
                            ? LeadModuleListData?.city
                            : "--/--"}
                        </div>
                      </td>
                    );
                  } else if (header?.value == "lead_received_on") {
                    return (
                      <td className="text-left" style={{ minWidth: "50px" }}>
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.lead_received_on
                            ? LeadModuleListData?.lead_received_on
                            : "--/--"}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "status") {
                    return (
                      <td className="text-left">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            gap: "3px",
                          }}
                        >
                          <label className="switchs m-0">
                            <input
                              type="checkbox"
                              checked={LeadModuleListData?.status}
                              onChange={() =>
                                handleChangeLeadStatus(LeadModuleListData)
                              }
                            />
                            <span className="sliders rounds"></span>
                          </label>
                          {/* Enabled */}
                        </div>
                      </td>
                    );
                  } else if (header?.value == "business_nature") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.business_nature
                            ? LeadModuleListData?.business_nature
                            : "--/--"}
                        </div>
                      </td>
                    );
                  } else if (header?.value == "turnover_in_crores") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.turnover_in_crores
                            ? LeadModuleListData?.turnover_in_crores
                            : "--/--"}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "stage") {
                    return (
                      <td
                        className="text-left"
                        style={{ minWidth: "262px", fontSize: "12px" }}
                      >
                        <div
                          style={{ alignItems: "center", paddingTop: "14px" }}
                        >
                          <span
                            style={
                              LeadModuleListData?.stage
                                ? styleColor(LeadModuleListData?.stage)
                                : blank()
                            }
                          >
                            {LeadModuleListData?.stage
                              ? LeadModuleListData?.stage
                              : "--/--"}
                          </span>
                        </div>
                      </td>
                    );
                  } else if (header?.value == "assigned_to") {
                    return (
                      <td style={{ minWidth: "180px" }}>
                        {LeadModuleListData?.assigned_to?.first_name ? (
                          <div
                            className="ml-2"
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                              gap: "7px",
                            }}
                          >
                            <CircularAvatar
                              name={`${LeadModuleListData?.assigned_to?.first_name} ${LeadModuleListData?.assigned_to?.last_name}`}
                              image={
                                LeadModuleListData?.assigned_to?.profile_pic &&
                                LeadModuleListData?.assigned_to?.profile_pic
                                  ?.file_url
                              }
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <span>
                                {LeadModuleListData?.assigned_to?.first_name}{" "}
                                {LeadModuleListData?.assigned_to?.last_name}
                              </span>
                            </div>
                          </div>
                        ) : (
                          "--/--"
                        )}
                      </td>
                    );
                  } else if (header?.value == "comment_by") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          {LeadModuleListData?.last_comment?.commented_by_name
                            ? LeadModuleListData?.last_comment
                                ?.commented_by_name
                            : "--/--"}
                        </div>
                      </td>
                    );
                  } else if (header?.value === "updated_by") {
                    return (
                      <td style={{ width: "180px" }}>
                        <div style={{ lineHeight: "1.5" }}>
                          <UpdatedByAndUpdatedAt
                            firstName={
                              LeadModuleListData?.updated_by?.first_name
                            }
                            lastName={LeadModuleListData?.updated_by?.last_name}
                            profilePic={
                              LeadModuleListData?.updated_by?.profile_pic
                                ?.file_url
                            }
                            updatedAt={formateDateWithTime(
                              LeadModuleListData?.updated_at
                            )}
                          />
                        </div>
                      </td>
                    );
                  } else if (header?.value == "lead_category") {
                    return (
                      <td className="text-left">
                        <div style={{ paddingTop: "14px" }}>
                          <span
                            style={
                              LeadModuleListData?.lead_category
                                ? styleColor(LeadModuleListData?.lead_category)
                                : blank()
                            }
                          >
                            {LeadModuleListData?.lead_category
                              ? LeadModuleListData?.lead_category
                              : "--/--"}
                          </span>
                        </div>
                      </td>
                    );
                  }
                  return <td>{LeadModuleListData[header.value]}</td>;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default LeadModuleTableData;
